module.exports = __webpack_public_path__ + "合作10.png?594c4d199309ae24d7db657c4ba77dae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作10.png
// module id = 652
// module chunks = 0